'use client';

import { SCREEN_SIZE } from '@fe-common-utils/constants/screen';
import { styled } from '@linaria/react';
import { memo, useEffect, useState } from 'react';
import CollectionSaveButton from '@fe-news/components/atoms/CollectionSaveButton';
import { CustomEventName, GTMEventKey } from '@fe-cnyes/fe-common-gtm';
import ShareTab from '@fe-news/components/AnueTopBar/ShareTab';
import { SELECT_DESKTOP_TABS } from './action';
import CommentButton from './CommentButton';

type TabConfigType = {
  title?: string;
  icon: string;
};

const ShareContainer = styled.nav`
  height: 100%;
  position: absolute;
  bottom: 0;
  left: -50px;
  display: flex;
  flex-direction: column-reverse;
`;

const SplitLabel = styled.p`
  height: 20px;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.5px;
  color: #848d97;
  text-align: center;
`;

const DesktopContainer = styled.section`
  position: sticky;
  bottom: 20%;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media screen and (max-width: ${SCREEN_SIZE.DESKTOP}px) {
    display: none;
  }
`;

type DesktopBarProps = {
  commentCount: number;
  newsId: number;
  title: string;
};

const DesktopBar: React.FC<DesktopBarProps> = ({ commentCount, newsId, title }) => {
  const [tabs, setTabs] = useState<TabConfigType[]>([]);

  useEffect(() => {
    setTabs(SELECT_DESKTOP_TABS);
  }, []);

  return (
    <ShareContainer>
      <DesktopContainer>
        {tabs.map((tab, index) => {
          const key = `${tab.icon}-${index}`;

          if (tab.title) return <SplitLabel key={key}>{tab.title}</SplitLabel>;

          return <ShareTab key={key} {...tab} />;
        })}
        <CollectionSaveButton
          newsId={newsId}
          gtmEvent={{
            [GTMEventKey.EVENT_NAME]: CustomEventName.FAVORITE,
            [GTMEventKey.SECTION]: 'News_Article',
            [GTMEventKey.CLICK_ITEM]: `${newsId}_${title}`
          }}
          isShowNewTip
        />
        <CommentButton commentCount={commentCount} />
      </DesktopContainer>
    </ShareContainer>
  );
};

export default memo(DesktopBar);
